import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";
import { Dispatch, SetStateAction } from "react";

const editUser = async (
  body: {
    firstName: string;
    lastName: string;
    mobile: string;
    email: string;
    streetAddress?: string;
    postalCode?: string;
    city?: string;
    stateRegion?: string;
    countryRegion?: string;
    additionalEmails?: string[];
    force?: boolean;
  },
  userId: string,
) => {
  return fetch(`/api/users/${userId}`, "PATCH", body);
};

export const useUserEditMutation = (
  onOpenChange: (open: boolean) => void,
  setShowConfirmModal: (show: boolean) => void,
  userId: string,
  setShouldRefetch: Dispatch<SetStateAction<boolean>>,
) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: {
      firstName: string;
      lastName: string;
      mobile: string;
      email: string;
      streetAddress?: string;
      postalCode?: string;
      city?: string;
      stateRegion?: string;
      countryRegion?: string;
      toastId: any;
      additionalEmails?: string[];
      force?: boolean;
    }) => {
      return editUser(data, userId);
    },
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Success",
        description: "Customer data updated successfully!",
        variant: "default",
      });

      onOpenChange(false);
      setShouldRefetch(true);
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      if (error.message.includes("Primary email is already in use by another user.")) {
        setShowConfirmModal(true);
      } else {
        toast({
          title: "Error",
          description: error.message || "Failed to update customer email!",
          variant: "destructive",
        });
      }
    },
  });
};
